const SportCodes = Object.freeze({
    FlagFootball: "flagfball",
    Football: "fball",
    Tennis: "mten",
    WomenTennis: "wten"
});

export const getSportDisplayName = (sportCode) => {
    switch (sportCode) {
        case SportCodes.WomenTennis:
            return "Women's Tennis";
        case SportCodes.Tennis:
            return "Men's Tennis";
        default:
            return Object.keys(SportCodes)
                .find((key) => SportCodes[key] === sportCode)
                .replace(/([A-Z])/g, " $1")
                .trim();
    }
};

export default SportCodes;
